import React from 'react';
import { useGrants } from '../../Data/Business';
import Loading from '../Loading';
import API from '../../Services/API';

export default ({userId, empty, you = 'You'}) => {
    const {keyedByUserId, isLoading} = useGrants();

    if (userId === null) {
        return empty ?? <span className="text-muted">-</span>;
    }

    if (you && userId === API.jwt('sub')) {
        return you;
    }

    if (isLoading) {
        return <Loading inline />;
    }

    return keyedByUserId[userId] ?? 'Unknown user';
}
